import auth from "../../auth/auth";

const CallBack = () => {
    const currUrl = window.location.href;
    console.log(currUrl)
    auth.auth.parseCognitoWebResponse(currUrl);
    return(<></>)
}

export default CallBack;